webpackJsonp(["docs"],{

/***/ "./docs/docs_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);


function addMousetrapClick(el, key) {
  el.addEventListener('click', function () {
    return __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.trigger(key);
  });
}

function domContentLoaded() {
  addMousetrapClick(document.querySelector('.js-trigger-shortcut'), '?');
  addMousetrapClick(document.querySelector('.js-trigger-search-bar'), 's');
}

document.addEventListener('DOMContentLoaded', domContentLoaded);

/***/ })

},["./docs/docs_bundle.js"]);


// WEBPACK FOOTER //
// docs.f2e080cbcacf3f8c43e0.bundle.js